import settings from '@/settings.json';

export default {

  load() {
    // store.commit('setSettings', data);
  },

  get(key) {
    // var settings = store.getters.getSettings;
    var value = "";
    if(settings[key]) {
      value = settings[key];
    }
    // console.log(key, "-", value);
    return value;
  }
}